import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest'
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection'
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute'

const Print = () => {
    // const { state } = useLocation()
    // console.log(state)
    const [subtopicList, setSubtopicList] = useState([])

    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    // const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    const [key, setKey] = useState(window.location?.search)



    useEffect(() => {
        // const key = window.location?.search ?? "";
        const syType = new URLSearchParams(key).get("syType");
        const SyllabusStructureMasterId = new URLSearchParams(key).get("SyllabusStructureMasterId");
        const SubjectMasterId = new URLSearchParams(key).get("SubjectMasterId");
        const LessonMasterId = new URLSearchParams(key).get("LessonMasterId");
        const TopicMasterId = new URLSearchParams(key).get("TopicMasterId");
        const SubTopicId = new URLSearchParams(key).get("SubTopicId");
        const instituteMasterId = new URLSearchParams(key).get("instituteMasterId");
        const sectionMasterId = new URLSearchParams(key).get("sectionMasterId");

        console.log(syType, SyllabusStructureMasterId, SubjectMasterId)


        if (syType == "B") {
            if (SubjectMasterId !== '') {
                let apiUrl = `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

                if (SyllabusStructureMasterId) {
                    apiUrl += `sectionSyllabusStructureMasterId=${SyllabusStructureMasterId}&`;
                }
                if (SubjectMasterId) {
                    apiUrl += `instituteSubjectMasterId=${SubjectMasterId}&`
                }
                if (LessonMasterId) {
                    apiUrl += `sectionLessonMasterId=${LessonMasterId}&`;
                }
                if (TopicMasterId) {
                    apiUrl += `sectionTopicMasterId=${TopicMasterId}&`;
                }
                if (SubTopicId) {
                    apiUrl += `sectionSubTopicId=${SubTopicId}&`;
                }
                apiUrl = apiUrl.replace(/&$/, '');
                authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                    .then(response => {
                        setSubtopicList(response.data.result);
                        console.log('Data:', response.data);
                    })
                    .catch(error => {
                        setSubtopicList(error?.response?.data.result);
                        console.error('Error fetching data:', error);
                        const errorMsg = error?.response?.data?.message || 'Something went wrong!';

                    });
            }
        }

        if (syType == "I") {
            if (SubjectMasterId !== '') {
                let apiUrl = `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&`;
                if (SyllabusStructureMasterId) {
                    apiUrl += `instituteSyllabusStructureMasterId=${SyllabusStructureMasterId}&`;
                }
                if (SubjectMasterId) {
                    apiUrl += `instituteSubjectMasterId=${SubjectMasterId}&`
                }
                if (LessonMasterId) {
                    apiUrl += `instituteLessonMasterId=${LessonMasterId}&`;
                }
                if (TopicMasterId) {
                    apiUrl += `instituteTopicMasterId=${TopicMasterId}&`;
                }
                if (SubTopicId) {
                    apiUrl += `instituteSubTopicId=${SubTopicId}&`;
                }
                apiUrl = apiUrl.replace(/&$/, '');
                authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                    .then(response => {
                        setSubtopicList(response.data.result);
                        console.log('Data:', response.data);
                    })
                    .catch(error => {
                        setSubtopicList(error?.response?.data.result);
                        console.error('Error fetching data:', error);
                        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    });
            }
        }

        if (syType == "A") {
            if (SubjectMasterId !== '') {
                let apiUrl = '/get-sub-topic-master-list?';
                if (SyllabusStructureMasterId) {
                    apiUrl += `syllabusStructureId=${SyllabusStructureMasterId}&`;
                }
                if (SubjectMasterId) {
                    apiUrl += `subjectMasterId=${SubjectMasterId}&`
                }
                if (LessonMasterId) {
                    apiUrl += `lessonId=${LessonMasterId}&`;
                }
                if (TopicMasterId) {
                    apiUrl += `topicId=${TopicMasterId}&`;
                }
                if (SubTopicId) {
                    apiUrl += `subTopicId=${SubTopicId}&`;
                }
                apiUrl = apiUrl.replace(/&$/, '');
                authorizedAxios && authorizedAxios.get(apiUrl)
                    .then(response => {
                        setSubtopicList(response.data.result);
                        console.log('Data:', response.data);
                    })
                    .catch(error => {
                        setSubtopicList(error?.response?.data.result);
                        console.error('Error fetching data:', error);
                        const errorMsg = error?.response?.data?.message || 'Something went wrong!';

                    });
            }
        }
    }, [key]);


    useEffect(() => {
        subtopicList.length !== 0 && window.print()
    }, [subtopicList])


    return (
        subtopicList?.map((item, index) => (

            <div class="content_book_wrap">
                <div className="row">
                    <div className="book">
                        <div className='lesson_area'>
                            <div className='lesson_no'>
                                <div className='info'>
                                    <span className='capt'>Class:</span>
                                    <span className='value'>{item?.subTopicMasterSyllabusStructureMasterDetails?.gradeMasterDetails?.gradeName}</span>
                                </div>
                                <div className='info'>
                                    <span className='capt'>Subject:</span>
                                    <span className='value'>{item?.subjectMasterDetails?.subjectName}</span>
                                </div>
                            </div>

                            <div className='chapter_name'>
                                <div className='info'>
                                    <span className='capt'>Chapter Name: </span>
                                    <span className='value'>{item?.subTopicMasterLessonMasterDetails?.lessonName}</span>
                                </div>
                            </div>
                        </div>
                        <div className="page" dangerouslySetInnerHTML={{ __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${item?.details}</div>` }} ></div>

                        <div className='page_no_area'>
                            <div className='page_no'>
                                <span>{index + 1} of {subtopicList?.length}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        ))



    )
}

export default Print